import React, { ReactElement } from 'react'
import { LinkIfLoggedInOtherwiseTextProps } from '@/components/static/StudyMaterialsGuidePage/GuideComponents/LinkIfLoggedInOtherwiseText/LinkIfLoggedInOtherwiseText.types'
import { reusableCssClass } from '@/utils/reusableCssClasses'
import Link from 'next/link'

export const LinkIfLoggedInOtherwiseText: React.FC<
    LinkIfLoggedInOtherwiseTextProps
> = (props): ReactElement => {
    if (props.isLoggedIn) {
        return (
            <Link
                href={props.relativePath}
                className={reusableCssClass.clickableText}
            >
                {props.text}
            </Link>
        )
    } else {
        return <span>{props.text}</span>
    }
}
